import { AuthStrategy } from './lib/auth/strategy';
import { LogLevel } from './lib/logger';
import { ColorScheme, PrimaryColor } from './styles/theme/types';

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
};

export const clarityConfig = {
  containerId: process.env.REACT_APP_CLARITY_CONTAINER_ID
};

export const mixpanelConfig = {
  token: process.env.REACT_APP_MIXPANEL_TOKEN
};

export const mapboxConfig = {
  apiKey: process.env.REACT_APP_MAPBOX_API_KEY
};

export const api = process.env.REACT_APP_API_URL;

export interface Config {
  site: {
    name: string;
    description: string;
    colorScheme: ColorScheme;
    primaryColor: PrimaryColor;
    themeColor: string;
  };
  logLevel: keyof typeof LogLevel;
  auth: { strategy: keyof typeof AuthStrategy };
  auth0: { domain?: string; clientId?: string };
  mapbox: { apiKey?: string };
  gtm?: { id?: string };
}

export const config = {
  site: {
    name: 'MakeItLab',
    description: '',
    colorScheme: 'light',
    themeColor: '#090a0b',
    primaryColor: 'neonBlue',
  },
  logLevel: (process.env.REACT_APP_LOG_LEVEL as keyof typeof LogLevel) || LogLevel.ALL,
  auth: { strategy: (process.env.REACT_APP_AUTH_STRATEGY as keyof typeof AuthStrategy) || AuthStrategy.CUSTOM },
  auth0: { domain: process.env.REACT_APP_AUTH0_DOMAIN, clientId: process.env.REACT_APP_AUTH0_CLIENT_ID },
  
  mapbox: { apiKey: process.env.REACT_APP_MAPBOX_API_KEY },
  gtm: { id: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID },
} satisfies Config;
